export class ManadatoryFieldsDataModel {

    SlNo: string;

    FieldName: string;

    MandatoryFlag: boolean;

    PromptFlag: boolean;

    CostCenterName: string;

    Modified: string;

    DateModified: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/Registration/MandatoryFieldsDataModel.ts